<template>
    <v-badge v-if="canReview" :value="pendingCount > 0" :content="pendingCount > 99 ? '99+' : pendingCount"
        color="warning" overlap offset-x="14" offset-y="14">
        <v-btn outlined class="text-none text-no-wrap" :to="{ name: 'SessionReviews' }">
            <v-icon left small>mdi-flag-outline</v-icon>
            Needs review
        </v-btn>
    </v-badge>
</template>

<script>
export default {
    name: 'SessionReviewsButton',

    data() {
        return { pendingCount: 0 };
    },

    computed: {
        canReview() {
            return [1, 2, 11].includes(this.$store.getters['auth/get_user']?.role_id);
        },
    },

    mounted() {
        if (this.canReview) this.loadCount();
    },

    methods: {
        async loadCount() {
            try {
                const res = await this.$axios.get('api/agent/session-reviews', { status: 'pending' });
                this.pendingCount = res.data?.response ? res.data.sessions.length : 0;
            } catch (e) {
                // Indicator only; the page itself reports load errors.
                this.pendingCount = 0;
            }
        },
    },
};
</script>
